import TitlePage from "@components/atoms/TitlePage/TitlePage";
import GenericTable from "../GenericTable/GenericTable";
import { IRemisionUI } from "src/types/organisms";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import RemisionFilters from "@components/molecules/RemisionFilters/RemisionFilters";
const RemisionesUI = ({
  isLoading,
  showError,
  closeError,
  errorMessage,
  headers,
  rows,
  onClick,
  pages,
  currentPage,
  onChangePage,
  onSearch,
  onSearchClick,
  handleStatusFilter
}: IRemisionUI) => {
  return <>
      <TitlePage title="Remisiones" subtitle="Supervisa el estado de tus remisiones y sus clientes de manera centralizada." />
      <GenericTable isLoading={isLoading} title="Lista de remisiones" buttonLabel="Crear remisión" onClick={onClick} headers={headers} rows={rows} pages={pages} currentPage={currentPage} onChangePage={onChangePage} emptyMessage="Sin remisiones encontradas" searchLabel="Buscar cliente" onSearch={onSearch} onSearchClick={onSearchClick} moreFilters={<RemisionFilters handleStatusFilter={handleStatusFilter} />} />
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default RemisionesUI;